import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { utils, write, read } from 'xlsx';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
function Merge() { }
if (false) {
    /** @type {?} */
    Merge.prototype.s;
    /** @type {?} */
    Merge.prototype.e;
}
/**
 * @record
 */
function ExportOptions() { }
if (false) {
    /** @type {?|undefined} */
    ExportOptions.prototype.fileName;
    /** @type {?|undefined} */
    ExportOptions.prototype.headers;
    /** @type {?|undefined} */
    ExportOptions.prototype.sheetNames;
    /** @type {?|undefined} */
    ExportOptions.prototype.merges;
}
/**
 * @record
 */
function ImportOptions() { }
if (false) {
    /** @type {?|undefined} */
    ImportOptions.prototype.headerRows;
    /** @type {?|undefined} */
    ImportOptions.prototype.headerKeys;
}
class NgxXLSXService {
    constructor() {
        this.excelType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        this.excelExtension = '.xlsx';
    }
    /**
     * @private
     * @param {?} buffer
     * @param {?} fileName
     * @return {?}
     */
    saveAsExcelFile(buffer, fileName) {
        /** @type {?} */
        const arrayBuffer = new ArrayBuffer(buffer.length);
        /** @type {?} */
        const view = new Uint8Array(arrayBuffer);
        for (let i = 0; i !== buffer.length; ++i) {
            view[i] = buffer.charCodeAt(i) & 0xFF;
        }
        /** @type {?} */
        const data = new Blob([arrayBuffer], {
            type: this.excelType
        });
        saveAs(data, fileName + this.excelExtension);
    }
    /**
     * @private
     * @param {?} i
     * @return {?}
     */
    numberToChart(i) {
        /** @type {?} */
        let chartCode = '';
        i = i + 1;
        while (i > 26) {
            /** @type {?} */
            let count = Number.parseInt(`${i / 26}`, 10);
            /** @type {?} */
            let remainder = i % 26;
            if (remainder === 0) {
                remainder = 26;
                count--;
                chartCode = String.fromCharCode(64 + Number.parseInt(`${remainder}`, 10)) + chartCode;
            }
            else {
                chartCode = String.fromCharCode(64 + Number.parseInt(`${remainder}`, 10)) + chartCode;
            }
            i = count;
        }
        chartCode = String.fromCharCode(64 + Number.parseInt(`${i}`, 10)) + chartCode;
        return chartCode;
    }
    /**
     * @private
     * @param {?} headers
     * @param {?} breakpoint
     * @return {?}
     */
    validationHeaders(headers, breakpoint) {
        /** @type {?} */
        const result = [];
        for (let i = 0, length = headers.length; i < length; i += breakpoint) {
            result.push(headers.slice(i, i + breakpoint));
        }
        result.map((/**
         * @param {?} _
         * @param {?} index
         * @return {?}
         */
        (_, index) => {
            if (result[index].length !== breakpoint) {
                throw new Error('ngx-xlsx: Parameter "headers" length mismatch');
            }
        }));
        return result;
    }
    /**
     * @private
     * @param {?} data
     * @param {?} __1
     * @return {?}
     */
    builtSheet(data, { headers, merges }) {
        /** @type {?} */
        const json = JSON.parse(JSON.stringify(data));
        /* add headers rows */
        headers.map((/**
         * @param {?} _
         * @return {?}
         */
        _ => {
            json.unshift({});
        }));
        /** @type {?} */
        const worksheet = utils.json_to_sheet(json, { skipHeader: true });
        /* custom header */
        if (headers && headers.length !== 0) {
            if (Array.isArray(headers[0])) {
                for (let i = 0; i < headers.length; i++) {
                    for (let j = 0; j < headers[i].length; j++) {
                        worksheet[this.numberToChart((j)) + (i + 1)] = { v: headers[i][j] };
                    }
                }
            }
        }
        /* custom merge */
        if (merges && merges.length > 0) {
            if (!worksheet['!merges']) {
                worksheet['!merges'] = [];
            }
            merges.map((/**
             * @param {?} item
             * @return {?}
             */
            item => {
                if (Array.isArray(item)) {
                    /** @type {?} */
                    const items = (/** @type {?} */ ((/** @type {?} */ (item.toString().split(',')))));
                    /** @type {?} */
                    const merge = {
                        s: {
                            r: items[0],
                            c: items[1]
                        },
                        e: {
                            r: items[2],
                            c: items[3]
                        }
                    };
                    worksheet['!merges'].push(merge);
                }
                else {
                    worksheet['!merges'].push(utils.decode_range((/** @type {?} */ ((/** @type {?} */ (item))))));
                }
            }));
        }
        return worksheet;
    }
    /**
     * @param {?} json
     * @param {?=} __1
     * @return {?}
     */
    exportAsExcelFile(json, { fileName = `${new Date().getTime()}`, headers = [], sheetNames = [], merges = [] } = {}) {
        /* slice headers by columns */
        /** @type {?} */
        let validHeaders = [];
        /* excelFileName is required */
        if (!fileName) {
            throw new Error('ngx-xlsx: Parameter "fileName" is required');
        }
        /* json is required */
        if (!json || !json.length) {
            throw new Error('ngx-xlsx: Parameter "json" is required');
        }
        /* validate headers length */
        if (headers && headers.length) {
            if (Array.isArray(headers[0])) {
                headers.map((/**
                 * @param {?} _
                 * @param {?} index
                 * @return {?}
                 */
                (_, index) => {
                    /** @type {?} */
                    const columns = Object.keys(json[index][0]).length;
                    validHeaders = this.validationHeaders((/** @type {?} */ (headers[index])), columns);
                }));
            }
            else {
                /** @type {?} */
                const columns = Object.keys(Array.isArray(json[0]) ? json[0][0] : json[0]).length;
                validHeaders = this.validationHeaders((/** @type {?} */ (headers)), columns);
            }
        }
        /* validate sheetNames length */
        if (sheetNames && sheetNames.length) {
            if (Array.isArray(json[0]) ? sheetNames.length !== json.length : sheetNames.length !== 1) {
                throw new Error('ngx-xlsx: Parameter "sheetNames" length mismatch');
            }
        }
        /* Workbook Object */
        /* workbook.SheetNames is an ordered list of the sheets in the workbook */
        /** @type {?} */
        const workbook = { SheetNames: [], Sheets: {} };
        /* multi-sheet */
        if (Array.isArray(json[0])) {
            json.map((/**
             * @param {?} data
             * @param {?} index
             * @return {?}
             */
            (data, index) => {
                workbook.SheetNames.push(sheetNames && sheetNames.length ? sheetNames[index] : `Sheet${index + 1}`);
                /** @type {?} */
                const sheetHeaders = (/** @type {?} */ ((Array.isArray(headers[0]) ? headers[index] : headers)));
                validHeaders = this.validationHeaders(sheetHeaders, Object.keys(data[0]).length);
                workbook.Sheets[workbook.SheetNames[index]] = this.builtSheet(data, { headers: validHeaders, merges });
            }));
        }
        else {
            workbook.SheetNames.push(sheetNames && sheetNames.length ? sheetNames[0] : `Sheet${1}`);
            workbook.Sheets[workbook.SheetNames[0]] = this.builtSheet(json, { headers: validHeaders, merges });
        }
        /** @type {?} */
        const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'buffer' });
        this.saveAsExcelFile(excelBuffer, fileName);
    }
    /**
     * @param {?} file
     * @param {?=} __1
     * @return {?}
     */
    importForExcelFile(file, { headerRows = 1, headerKeys = [] } = {}) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            /** @type {?} */
            const result = [];
            /** @type {?} */
            const reader = new FileReader();
            reader.onload = (/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                /* read workbook */
                /** @type {?} */
                const bstr = event.target.result;
                /** @type {?} */
                const workbook = read(bstr, { type: 'binary' });
                /* grab first sheet */
                workbook.SheetNames.map((/**
                 * @param {?} sheetName
                 * @param {?} index
                 * @return {?}
                 */
                (sheetName, index) => {
                    /** @type {?} */
                    const worksheet = workbook.Sheets[sheetName];
                    /** @type {?} */
                    const header = (/** @type {?} */ ((Array.isArray(headerKeys[0]) ? headerKeys[index] : headerKeys)));
                    /** @type {?} */
                    const data = (/** @type {?} */ ((utils.sheet_to_json(worksheet, {
                        raw: true,
                        header: header.length ? header : void (0)
                    }))));
                    result.push(header.length ? data.slice(headerRows, data.length) : data);
                }));
                observer.next(result.length > 1 ? result : result[0]);
                observer.complete();
            });
            reader.onerror = (/**
             * @param {?} error
             * @return {?}
             */
            (error) => {
                observer.error(error);
            });
            reader.readAsBinaryString(file);
        }));
    }
}
NgxXLSXService.ɵfac = function NgxXLSXService_Factory(t) { return new (t || NgxXLSXService)(); };
NgxXLSXService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxXLSXService, factory: NgxXLSXService.ɵfac });
/** @nocollapse */
NgxXLSXService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxXLSXService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    NgxXLSXService.prototype.excelType;
    /**
     * @type {?}
     * @private
     */
    NgxXLSXService.prototype.excelExtension;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxXLSXModule {
}
NgxXLSXModule.ɵfac = function NgxXLSXModule_Factory(t) { return new (t || NgxXLSXModule)(); };
NgxXLSXModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxXLSXModule });
NgxXLSXModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NgxXLSXService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxXLSXModule, [{
        type: NgModule,
        args: [{
                providers: [NgxXLSXService]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxXLSXModule, NgxXLSXService };

